// extracted by mini-css-extract-plugin
export default {"cart_drinks":"CartDrinks_cart_drinks__ow09J"};